import React, { useContext, useState } from 'react';
import { TranslatorContext } from '@jutro/locale';
import SagaCommonMessages from 'sg-common-messages';
import { Link } from '@jutro/components';

function useSgExpandableLabel(messagePart1, messagePart2, messageParams, id) {
    const translator = useContext(TranslatorContext);
    const showMoreText = translator(SagaCommonMessages.SubLabelShowMore);
    const showLessText = translator(SagaCommonMessages.SubLabelShowLess);
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = (event) => {
        if (event) {
            event.preventDefault();
        }
        setIsExpanded(!isExpanded);
    };
    return (
        <>
            <div onClick={toggleExpanded} onKeyPress={toggleExpanded} role="button" tabIndex="0">
                {translator(messagePart1, messageParams)}
                {isExpanded
                && (
                    <>
                        {' '}
                        {translator(messagePart2, messageParams)}
                    </>
                )
                }
                <div className="sgShowMoreLessLinkContainer">
                    <Link
                        href="/"
                        id={id}
                    >
                        <span>{isExpanded ? showLessText : showMoreText}</span>
                    </Link>
                    <span className={`${isExpanded ? 'sgShowLessArrow' : 'sgShowMoreArrow'}`} />
                </div>
            </div>
        </>
    );
}

export default useSgExpandableLabel;
